import { ArrayUtils } from '@colonist/utils';
import { CardDataController } from '@colonist/game-card-types';
export class BaseCardValidator {
    hasCardsInInventory(cardEnums) {
        const uniqueCardEnums = ArrayUtils.removeDuplicatesFromArray(cardEnums);
        for (const uniqueCard of uniqueCardEnums){
            const amountInInventory = ArrayUtils.countOccurenceOfValueInArray(this.cards, uniqueCard);
            const amountRequested = ArrayUtils.countOccurenceOfValueInArray(cardEnums, uniqueCard);
            if (amountInInventory < amountRequested) return false;
        }
        return true;
    }
    getCardsOfType(cardType) {
        const cardsOfType = [];
        for (const card of this.cards){
            const cardData = CardDataController.getCardDataForCard(card);
            if (cardData == undefined) continue;
            if (cardData.cardTypeEnum != cardType) continue;
            cardsOfType.push(card);
        }
        return cardsOfType;
    }
    hasCardOfType(cardType) {
        for (const card of this.cards){
            const cardData = CardDataController.getCardDataForCard(card);
            if (cardData == undefined) continue;
            if (cardData.cardTypeEnum == cardType) return true;
        }
        return false;
    }
    getNumberOfCardsInInventory() {
        return this.cards.length;
    }
    getCardCountOfType(cardType) {
        return this.getCardsOfType(cardType).length;
    }
    getCardCountForCard(cardEnum) {
        return ArrayUtils.countOccurenceOfValueInArray(this.cards, cardEnum);
    }
    constructor(state){
        this.state = state;
    }
}
